// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap_BbExl clearfix","box":"index_box_zdcK7 fr","box_0":"index_box_0_hnkk-","box_1":"index_box_1_3MQMh"};